import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4551 2.74384C19.5966 3.13315 19.3956 3.56342 19.0063 3.70487L18.0002 4.07043V9.20939L21.9874 10.5384C22.3803 10.6694 22.5927 11.0942 22.4617 11.4871C22.3307 11.8801 21.906 12.0925 21.513 11.9615L21.0002 11.7905V20.25H21.7502C22.1644 20.25 22.5002 20.5857 22.5002 21C22.5002 21.4142 22.1644 21.75 21.7502 21.75H2.2502C1.83599 21.75 1.5002 21.4142 1.5002 21C1.5002 20.5857 1.83599 20.25 2.2502 20.25H3.0002V9.52532L2.50646 9.70482C2.11718 9.84635 1.68687 9.6455 1.54534 9.25622C1.40381 8.86693 1.60466 8.43662 1.99395 8.2951L3.0002 7.92927V2.99996C3.0002 2.58575 3.33599 2.24996 3.7502 2.24996H6.7502C7.16442 2.24996 7.5002 2.58575 7.5002 2.99996V6.29311L18.4941 2.29505C18.8834 2.1536 19.3137 2.35453 19.4551 2.74384ZM6.0002 6.8386L4.5002 7.38393V3.74996H6.0002V6.8386ZM4.5002 8.97999V20.25H7.5002V16.125C7.5002 15.0897 8.33999 14.25 9.3752 14.25H11.6252C12.6604 14.25 13.5002 15.0897 13.5002 16.125V20.25H16.5002V9.76748C16.4999 9.7559 16.4999 9.74429 16.5002 9.73266V4.61581L7.00656 8.06879L4.5002 8.97999ZM18.0002 10.7905V20.25H19.5002V11.2905L18.0002 10.7905ZM9.0002 20.25H12.0002V16.125C12.0002 15.9182 11.832 15.75 11.6252 15.75H9.3752C9.16842 15.75 9.0002 15.9182 9.0002 16.125V20.25Z"
        fill={colorValue}
      />
    </svg>
  );
};
